// July-anchored academic calendar helpers
// Quarters: Jul–Sep (Q1) / Oct–Dec (Q2) / Jan–Mar (Q3) / Apr–Jun (Q4)
// Academic year: Jul 1 – Jun 30

/**
 * Returns {start, end} Date objects for the July-anchored academic quarter
 * that contains the given date (defaults to today).
 */
export function getCurrentQuarterRange(date = new Date()) {
    const month = date.getMonth() // 0-based: Jul=6, Oct=9, Jan=0, Apr=3
    const year = date.getFullYear()

    if (month >= 6 && month <= 8) {
        // Q1: Jul–Sep
        return {start: new Date(year, 6, 1), end: new Date(year, 8, 30)}
    } else if (month >= 9) {
        // Q2: Oct–Dec
        return {start: new Date(year, 9, 1), end: new Date(year, 11, 31)}
    } else if (month <= 2) {
        // Q3: Jan–Mar
        return {start: new Date(year, 0, 1), end: new Date(year, 2, 31)}
    } else {
        // Q4: Apr–Jun
        return {start: new Date(year, 3, 1), end: new Date(year, 5, 30)}
    }
}

/**
 * Returns true if the given Date is strictly in the future.
 */
export function isFuture(date) {
    return date > new Date()
}

/**
 * Returns an array of academic years (most recent first), each with 4 quarters.
 * Shape: [{ label, start, end, quarters: [{start, end}] }]
 */
export function getAcademicYears(count = 3) {
    const now = new Date()
    const month = now.getMonth() // 0-based
    const year = now.getFullYear()
    const currentAcademicYearStart = month >= 6 ? year : year - 1

    const years = []
    for (let i = 0; i < count; i++) {
        const ay = currentAcademicYearStart - i
        years.push({
            label: `${ay}–${ay + 1}`,
            start: new Date(ay, 6, 1),         // Jul 1
            end: new Date(ay + 1, 5, 30),       // Jun 30
            quarters: [
                {start: new Date(ay + 1, 3, 1),     end: new Date(ay + 1, 5, 30)},    // Apr–Jun (newest)
                {start: new Date(ay + 1, 0, 1),     end: new Date(ay + 1, 2, 31)},    // Jan–Mar
                {start: new Date(ay, 9, 1),         end: new Date(ay, 11, 31)},        // Oct–Dec
                {start: new Date(ay, 6, 1),         end: new Date(ay, 8, 30)},         // Jul–Sep (oldest)
            ],
        })
    }
    return years
}

/**
 * Formats a Date as "YYYY-MM-DD" string suitable for <input type="date">.
 */
export function toDateString(date) {
    const y = date.getFullYear()
    const m = String(date.getMonth() + 1).padStart(2, "0")
    const d = String(date.getDate()).padStart(2, "0")
    return `${y}-${m}-${d}`
}
